export type DeviceType = 'desktop' | 'tablet' | 'mobile';

export type DeviceAction =
  | 'show-original'      // Exibir vídeo original
  | 'show-alternative'   // Exibir vídeo alternativo
  | 'show-image';        // Substituir por imagem

export interface AlternativeVideo {
  videoId: string;
  videoTitle?: string;
  thumbnailUrl?: string;
}

export interface ImageReplacement {
  imageUrl: string;
  aspectRatio?: '16:9' | '9:16';
}

export interface DeviceRule {
  device: DeviceType;
  action: DeviceAction;
  alternativeVideo?: AlternativeVideo;
  imageReplacement?: ImageReplacement;
}

export interface ResponsivePlayerConfig {
  enabled: boolean;
  rules: DeviceRule[];
  fallbackBehavior: 'show-original' | 'hide';
}

export const defaultResponsivePlayerConfig: ResponsivePlayerConfig = {
  enabled: false,
  rules: [
    {
      device: 'desktop',
      action: 'show-original'
    },
    {
      device: 'tablet',
      action: 'show-original'
    },
    {
      device: 'mobile',
      action: 'show-original'
    }
  ],
  fallbackBehavior: 'show-original'
};